var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card mb-4 shadow-sm course"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.honor.image}})])}
var staticRenderFns = []

export { render, staticRenderFns }